// eslint-disable-next-line no-restricted-imports
import { LegalClientBeneficiaryFragment } from 'api/generated/graphql';
import { parseAmount } from 'api/requests/onboarding/helpers/parseAmount';
import {
  ControlOverEntity,
  ControlOverLegalClientStatusType,
} from 'api/types/entity/legal/beneficiary/controlOverEntity';

export const parseControlOverEntity = (
  data: LegalClientBeneficiaryFragment
): ControlOverEntity | undefined => {
  if (typeof data.directCapitalParticipationPercentage !== 'number')
    return undefined;

  return {
    directCapitalParticipationPercentage:
      data.directCapitalParticipationPercentage!,
    financialConditionAmount: data.financialConditionAmount
      ? parseAmount(data.financialConditionAmount)
      : undefined,
    hasControlOverLegalClient: data.hasControlOverLegalClient ?? undefined,
    indirectCapitalParticipationPercentage:
      data.indirectCapitalParticipationPercentage ?? undefined,

    controlOverLegalClientStatus: data.controlOverLegalClientStatus
      ? ControlOverLegalClientStatusType[data.controlOverLegalClientStatus]
      : undefined,
  };
};
